import { defineMessage } from 'react-intl';

export const emptyRowMessage = defineMessage({
  defaultMessage: 'You currently have no items in this {isReturn, select, true {return} other {shipment}}.',
  description: 'Text to indicate that the given shipment or return does not have any items associated with it.',
  id: 'bzGLwy',
});

export const addItemsButtonText = defineMessage({
  defaultMessage: 'Add Items',
  description: 'text for a button that will add items to a shipment',
  id: 'o2z5pl',
});
